export default function Analytics() {
  return (
    <div>
      <h2 className="text-2xl font-bold">Latest Events</h2>
    </div>
  );
}
